// src/composables/officialHolidays.js
import { ref } from 'vue'
import { supabase } from '../supabaseClient'

// 未ロード: null / ロード済み: Set<YYYY-MM-DD>
export const officialHolidays = ref(null)
let loadingPromise = null

/** JST の今日を YYYY-MM-DD（ゼロ埋め）で返す。iOS Safari でも曜日判定が狂わないよう Intl を優先 */
export const todayJST = () => {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date())
    const y = parts.find((p) => p.type === 'year')?.value
    const m = parts.find((p) => p.type === 'month')?.value
    const d = parts.find((p) => p.type === 'day')?.value
    if (y && m && d) return `${y}-${m}-${d}`
  } catch (_) {
    /* fall through */
  }
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'Asia/Tokyo' })
}

export async function ensureOfficialHolidays() {
  if (officialHolidays.value instanceof Set) return officialHolidays.value
  if (loadingPromise) return loadingPromise

  loadingPromise = (async () => {
    try {
      const { data, error } = await supabase
        .from('official_holidays')
        .select('date')
        .order('date', { ascending: true })

      if (error) throw error
      officialHolidays.value = new Set((data || []).map(h => h.date))
    } catch (e) {
      console.error('休日データ取得エラー:', e)
      // ★安全側：未ロード扱いのままにして、UIは無効化される
      officialHolidays.value = null
    } finally {
      const set = officialHolidays.value
      loadingPromise = null
      return set
    }
  })()

  return loadingPromise
}

// （任意）サインアウト等で初期化したい時用
export function resetOfficialHolidays() {
  officialHolidays.value = null
  loadingPromise = null
}
